export const COLUMN_WIDTH = {
  DATE: 190,
} as const
